import * as React from 'react';
import { StringMode } from '@comall-backend-builder/types';

export class StringReportsStatusMode extends StringMode {
    /**
     * 报表导入 导出结果
     */
    public getAvailableDisplayComponent(value: any, displayInfo: any) {
        const { row, conditionProperty } = displayInfo;
        let _value = '';

        // 处理状态
        const status: any = {
            WAIT_EXECUTE: '待处理',
            EXECUTING: '处理中',
            EXECUTED: '已处理'
        };

        // 已处理的状态
        const processStatus: any = {
            SUCCESS: '处理成功',
            ERROR: '处理失败',
            PART_SUCCESS: '部分成功'
        };

        if (value !== 'EXECUTED') {
            _value = status[value];
        } else {
            _value = processStatus[row[conditionProperty]];
        }

        return <span>{_value}</span>;
    }
}
